import { render, staticRenderFns } from "./ElementKeahlian.vue?vue&type=template&id=5c90c0ba&"
import script from "./ElementKeahlian.vue?vue&type=script&lang=js&"
export * from "./ElementKeahlian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports